import { I18nextTranslationKeys } from '@/i18n/i18next';

import {
  ChannelRecordingTaskActionEnum,
  ChannelRecordingTaskStateEnum,
  ChannelRecordingTaskTypeEnum,
} from '../types';

export const CHANNEL_RECORDING_TASK_TYPE_TO_LABEL: Record<
  ChannelRecordingTaskTypeEnum,
  I18nextTranslationKeys
> = {
  [ChannelRecordingTaskTypeEnum.MANUAL]: 'Manual',
  [ChannelRecordingTaskTypeEnum.URL_STREAM]: 'URL Stream',
  [ChannelRecordingTaskTypeEnum.FILE]: 'Fichero',
  [ChannelRecordingTaskTypeEnum.URL_FILE]: 'URL fichero',
  [ChannelRecordingTaskTypeEnum.SCHEDULED]: 'Automática',
};

export const CHANNEL_RECORDING_TASK_TYPE_TO_COLUMN_LABEL: Record<
  ChannelRecordingTaskTypeEnum,
  I18nextTranslationKeys
> = {
  [ChannelRecordingTaskTypeEnum.MANUAL]: 'Manual',
  [ChannelRecordingTaskTypeEnum.URL_STREAM]: 'Streaming',
  [ChannelRecordingTaskTypeEnum.FILE]: 'Fichero (Subida)',
  [ChannelRecordingTaskTypeEnum.URL_FILE]: 'Fichero (URL)',
  [ChannelRecordingTaskTypeEnum.SCHEDULED]: 'Automática',
};

export const CHANNEL_RECORDING_TASK_STATE_TO_LABEL: Record<
  ChannelRecordingTaskStateEnum,
  I18nextTranslationKeys
> = {
  [ChannelRecordingTaskStateEnum.PENDING]: 'Programada',
  [ChannelRecordingTaskStateEnum.RUNNING]: 'Grabando',
  [ChannelRecordingTaskStateEnum.COMPLETED]: 'Terminada',
  [ChannelRecordingTaskStateEnum.CANCELLED]: 'Cancelada',
  [ChannelRecordingTaskStateEnum.ERROR]: 'Error',
  [ChannelRecordingTaskStateEnum.STARTING]: 'Iniciando',
  [ChannelRecordingTaskStateEnum.PAUSED]: 'Pausada',
  [ChannelRecordingTaskStateEnum.TIMEOUT]: 'No programada',
  [ChannelRecordingTaskStateEnum.REMOVED]: 'Eliminada',
};

export const CHANNEL_RECORDING_TASK_STATE_TO_BACKGROUND_COLOR: Record<
  ChannelRecordingTaskStateEnum,
  string
> = {
  [ChannelRecordingTaskStateEnum.PENDING]: '',
  [ChannelRecordingTaskStateEnum.RUNNING]: 'bg-feedback-info-10/25',
  [ChannelRecordingTaskStateEnum.COMPLETED]: 'bg-opacity-success',
  [ChannelRecordingTaskStateEnum.CANCELLED]: 'bg-opacity-alert',
  [ChannelRecordingTaskStateEnum.ERROR]: 'bg-opacity-danger',
  [ChannelRecordingTaskStateEnum.STARTING]: '',
  [ChannelRecordingTaskStateEnum.PAUSED]: 'bg-bg-secondary-10',
  [ChannelRecordingTaskStateEnum.TIMEOUT]: 'bg-extra-25/[.15]',
  [ChannelRecordingTaskStateEnum.REMOVED]: '',
};

type NotificationProps = {
  title: I18nextTranslationKeys;
  description: I18nextTranslationKeys;
};

type NotificationData = {
  success: NotificationProps;
  error: NotificationProps;
};

export const CHANNEL_RECORDING_TASK_ACTION_TO_NOTIFICATION_DATA: Record<
  ChannelRecordingTaskActionEnum,
  NotificationData | null
> = {
  [ChannelRecordingTaskActionEnum.STOP]: {
    error: {
      title: 'No se ha cancelado la grabación',
      description: 'Ha habido un error durante el proceso, vuelva a intentarlo más tarde',
    },
    success: {
      title: 'Se ha cancelado la grabación',
      description: 'El proceso de grabación se ha desactivado con éxito',
    },
  },
  [ChannelRecordingTaskActionEnum.PAUSE]: {
    error: {
      title: 'No se ha pausado la grabación',
      description: 'Ha habido un error durante el proceso, vuelva a intentarlo más tarde',
    },
    success: {
      title: 'Se ha pausado el proceso de grabación',
      description: 'Para volver activarlo pulsar sobre relanzar',
    },
  },
  [ChannelRecordingTaskActionEnum.START]: null,
  [ChannelRecordingTaskActionEnum.REMOVE]: null,
  [ChannelRecordingTaskActionEnum.RELOAD]: null,
  [ChannelRecordingTaskActionEnum.UNPAUSE]: {
    error: {
      title: 'No se ha relanzado el proceso',
      description: 'Ha habido un error durante el proceso, vuelva a intentarlo más tarde',
    },
    success: {
      title: 'Se relanzado el proceso',
      description: 'El proceso de grabación se ha vuelto a activar',
    },
  },
  [ChannelRecordingTaskActionEnum.RESTART]: {
    error: {
      title: 'No se ha relanzado el proceso',
      description: 'Ha habido un error durante el proceso, vuelva a intentarlo más tarde',
    },
    success: {
      title: 'Se relanzado el proceso',
      description: 'El proceso de grabación se ha vuelto a activar',
    },
  },
};
